import React from 'react'
import { motion } from 'framer-motion'
import { Zap, Shield, Globe, Lock, Wifi, Smartphone, Clock, Users } from 'lucide-react'

const Features: React.FC = () => {
  const features = [
    {
      icon: Zap,
      title: '3.5G超高速带宽',
      description: '行业顶尖速度，比传统VPN快10倍，支持4K视频流畅播放',
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-50',
      delay: 0.1
    },
    {
      icon: Shield,
      title: '军事级加密保护',
      description: '采用AES-256加密技术，确保您的网络活动完全私密安全',
      color: 'text-green-500',
      bgColor: 'bg-green-50',
      delay: 0.2
    },
    {
      icon: Globe,
      title: '全球50+服务器',
      description: '覆盖美国、欧洲、亚洲等主要地区，智能选择最佳线路',
      color: 'text-blue-500',
      bgColor: 'bg-blue-50',
      delay: 0.3
    },
    {
      icon: Lock,
      title: '零日志政策',
      description: '严格遵循零日志政策，不记录任何用户活动数据',
      color: 'text-purple-500',
      bgColor: 'bg-purple-50',
      delay: 0.4
    },
    {
      icon: Wifi,
      title: '智能分流技术',
      description: '智能识别国内外网站，自动选择最优连接方式',
      color: 'text-indigo-500',
      bgColor: 'bg-indigo-50',
      delay: 0.5
    },
    {
      icon: Smartphone,
      title: '多平台支持',
      description: '支持iOS、Android、Windows、Mac等全平台设备',
      color: 'text-pink-500',
      bgColor: 'bg-pink-50',
      delay: 0.6
    }
  ]

  const stats = [
    { icon: Clock, value: '99.9%', label: '可用性', color: 'text-green-500' },
    { icon: Users, value: '100万+', label: '活跃用户', color: 'text-blue-500' },
    { icon: Globe, value: '50+', label: '国家地区', color: 'text-purple-500' },
    { icon: Zap, value: '<50ms', label: '平均延迟', color: 'text-orange-500' }
  ]

  return (
    <section id="features" className="py-20 bg-white">
      <div className="container-responsive">
        {/* 标题区域 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="mobile-heading font-bold text-gray-900 mb-4">
            为什么选择
            <span className="text-gradient"> 暴风加速器</span>
          </h2>
          <p className="mobile-text text-gray-600 max-w-3xl mx-auto">
            我们提供行业领先的VPN服务，结合先进技术和优质服务，
            为您打造极速、安全、稳定的网络体验
          </p>
        </motion.div>

        {/* 功能特性网格 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {features.map((feature) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: feature.delay }}
              className="card card-hover group"
            >
              <div className={`w-12 h-12 ${feature.bgColor} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <feature.icon className={`w-6 h-6 ${feature.color}`} />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* 统计数据 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-3xl p-8 md:p-12"
        >
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
              值得信赖的数据
            </h3>
            <p className="text-gray-600">
              用数据说话，让您了解我们的服务实力
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-center"
              >
                <div className={`w-16 h-16 mx-auto mb-4 bg-white rounded-2xl flex items-center justify-center shadow-lg`}>
                  <stat.icon className={`w-8 h-8 ${stat.color}`} />
                </div>
                <div className={`text-3xl md:text-4xl font-bold ${stat.color} mb-2`}>
                  {stat.value}
                </div>
                <div className="text-gray-600 font-medium">
                  {stat.label}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>


      </div>
    </section>
  )
}

export default Features
